<template>
  <div class="selectBG">
    <p>您的账号拥有多个权限信息，请选择下面的公司或者项目登陆</p>
    <!-- 目前后端返回字段不统一，无法写成一个，如果多个，建议后端字段统一 -->
    <!-- <div class="list-wrap">
      <div v-if="userType == 7">
        <div
          class="item"
          v-for="item in showList"
          :key="item.id"
          @click="clickCompony(item)"
        >
          {{item.companyName}}
        </div>
      </div>
      <div v-else-if="userType == 8">
        <div
          class="item"
          v-for="item in showList"
          :key="item.id"
          @click="clickCompony(item)"
        >
          {{item.projectName}}
        </div>
      </div>

    </div> -->
    <!-- @clickCompony="clickCompony" -->

    <div>
      <div class="b1">
        <p @click="clickCompony(data)">{{data.companyName}}
          <i
            style="float:right;margin-right:30px;cursor: pointer;"
            class="el-icon-bottom"
            v-if="data.treeCompanies && data.treeCompanies.length"
            @click.stop="$set(data,'showNode',data.showNode?false:true)"
          ></i>
        </p>
        <ThreeChild
          ref="threeChild"
          :list="data.treeCompanies"
          v-show="data.showNode"
        />
      </div>
      <div
        class="b1"
        v-for="s in data.subProjects"
        :key="s.porjectName"
        @click="clickProject(s)"
      >
        <p class="b1">{{s.porjectName}}</p>
      </div>
    </div>
  </div>

</template>

<script>
import ThreeChild from '@/components/ThreeChild'
import {
  Api_login
} from "@/api/api";

const COMPANY_USER = 7; // 公司人员
const PROJECT_USER = 8; // 项目人员
const UNIT_USER = 9; // 参建单位人员
const THIRD_PART_USER = 10; // 第三方人员
const other_USER = 11; // 其他人员
export default {
  components: {
    ThreeChild
  },
  data() {
    return {
      showList: [],
      userType: 0, // 用户类型
      data: {
        "id": 63,
        "companyName": "前端公司",
        "parentId": 0,
        "treeCompanies": [
          {
            "id": 64,
            "companyName": "前端分公司",
            "parentId": 63,
            "treeCompanies": [
              {
                "id": 66,
                "companyName": "分公司1111",
                "parentId": 64,
                "treeCompanies": [
                  {
                    "id": 66,
                    "companyName": "分公司1-1",
                    "parentId": 64,
                    subProjects: [
                      {
                        "id": 43,
                        "companyId": 66,
                        "porjectName": "分公司1-1-1"
                      }
                    ]
                  }
                ],
                "subProjects": [
                  {
                    "id": 43,
                    "companyId": 66,
                    "porjectName": "分公司1项目"
                  }
                ]
              },
              {
                "id": 67,
                "companyName": "分公司2",
                "parentId": 64,
                "treeCompanies": null,
                "subProjects": []
              }
            ],
            "subProjects": [
              {
                "id": 41,
                "companyId": 64,
                "porjectName": "项目1"
              },
              {
                "id": 42,
                "companyId": 64,
                "porjectName": "项目2"
              }
            ]
          }
        ],
        "subProjects": [
          {
            "id": 39,
            "companyId": 63,
            "porjectName": "前端项目"
          },
          {
            "id": 39,
            "companyId": 63,
            "porjectName": "前端项目2"
          }
        ]
      },
      defaultProps: {
        children: 'treeCompanies',
        label: 'companyName'
      }
    }
  },
  mounted() {
    this.init()
    this.getCompanyTree()
  },
  methods: {
    init() {
      this.userType = this.$route.query.userType * 1
      const companyId = this.$route.query.companyId
      switch (this.userType) {
        case COMPANY_USER://  公司人员
          this.getCompanyList(companyId)
          break;
        case PROJECT_USER://  项目人员
          this.getProjectList(companyId)
          break;
        case UNIT_USER://  参建单位人员
          // TODO 前端未开发
          break;
        case THIRD_PART_USER://  第三方人员
          // TODO 前端未开发
          break;
        case other_USER://  其他人员
          break;
        default:
      }
    },
    // 获取公司或者项目树
    getCompanyTree() {
      Api_login.getCompanyTree(this.$route.query.companyId).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.data = result.data
        }
      })
    },
    clickCompony(data) {
      this.$refs.threeChild.clickCompony(data)
    },
    clickProject(data) {
      this.$refs.threeChild.clickProject(data)
    },
    // 获取公司列表
    getCompanyList(companyId) {
      Api_login.getCompanyList(companyId).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          console.log(result.data)
          this.showList = result.data
        }
      })
    },
    // 获取项目列表
    getProjectList(companyId) {
      Api_login.getProjectList(companyId).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          console.log(result.data)
          this.showList = result.data
        }
      })
    },
  }
}
</script>

<style lang="scss">
.selectBG {
  text-align: center;
  padding-top: 50px;
  font-size: 32px;
  font-weight: bold;
  .b1 {
    width: 95%;
    float: right;
  }

  .b1 p {
    width: 100%;
    margin: 10px 0;
    // padding-left: 20px;
    border: 1px solid white;
    float: right;
    background: #072158;
    padding: 10px;
    font-size: 24px;
  }
  .list-wrap {
    box-sizing: border-box;
    width: 100%;
    padding: 50px 200px;
    .item {
      margin-bottom: 20px;
      height: 80px;
      line-height: 80px;
      background: rgba(11, 52, 114, 0.3);
      border: 1px solid rgba(54, 95, 125, 1);
      font-size: 24px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>